<template>
    <b-row>
        <b-col :cols="labelCols ? labelCols : 2">
            <label>
                {{ label }}
            </label>
        </b-col>
        <b-col :cols="cols*6" :sm="cols*4" :md="cols*2"	:lg="cols*2" :xl="cols">
            <div class="static-input-value">
                <router-link :to="link">{{ formattedValue }}</router-link>
            </div>
        </b-col>        
    </b-row>
</template>

<script>
export default {
  name: "rdkm-link-text",
  props: ["cols", "value", "label", "maxlength", "link", "labelCols"],
  computed: {
    formattedValue(val) {
        let length = this.maxlength || 10;
        if(this.value.length > length) {
          return this.value.substr(0, length - 1) + '...';
        }
        return this.value;
      }
    }
  }
</script>

